module.exports = __webpack_public_path__ + "static/img/Base.bf32594d.svg";